import api from '../../../core/api/client';

export const taskService = {
  async getProjectTasks(projectId) {
    try {
      const response = await api.get(`/projects/${projectId}/tasks`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async getMilestoneTasks(projectId, milestoneId) {
    try {
      const response = await api.get(`/projects/${projectId}/milestones/${milestoneId}/tasks`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async getMyTasks() {
    try {
      const response = await api.get('/tasks/me');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async getTasksInReview(projectId) {
    try {
      const response = await api.get(`/projects/${projectId}/tasks/in-review`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async createTask(projectId, taskData) {
    try {
      const response = await api.post(`/projects/${projectId}/tasks`, taskData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async getTaskById(taskId) {
    try {
      const response = await api.get(`/tasks/${taskId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async updateTask(taskId, updates) {
    try {
      const response = await api.patch(`/tasks/${taskId}`, updates);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async deleteTask(taskId) {
    try {
      const response = await api.delete(`/tasks/${taskId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async updateTaskStatus(taskId, status) {
    try {
      const response = await api.patch(`/tasks/${taskId}/status`, { status });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async reviewTask(taskId, approved, feedback) {
    try {
      const response = await api.post(`/tasks/${taskId}/review`, {
        approved,
        feedback,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};
